import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AdvisorKeys } from "web_myplann/Api/Advisor/AdvisorKeys";
import { invalidateAssignedAgents } from "web_myplann/Api/Advisor/invalidateAssignedAgents";
import { setMainAdvisorInCache } from "web_myplann/Api/Advisor/setMainAdvisorInCache";
import type { AssignedAgentsQueryData } from "web_myplann/Api/Advisor/Types/AssignedAgentsQueryData";
import {
	type PatchAgentIdMainV2FetchResponse,
	patchAgentIdMainV2,
	UserAgentStatusEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useAdvisorSetMainMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse<number, PatchAgentIdMainV2FetchResponse>(
			(advisorId) => patchAgentIdMainV2(advisorId),
		),
		onSuccess: (_response, advisorId) => {
			queryClient.setQueryData<AssignedAgentsQueryData>(
				AdvisorKeys.assignedAgents(UserAgentStatusEnum.Connected),
				(cached) => setMainAdvisorInCache(cached, advisorId),
			);

			return invalidateAssignedAgents(queryClient);
		},
	});
};
